import { useFormContext } from 'react-hook-form';

import type { WorkReallocateRatioFormData } from '@/component/Task';
import { useRatioDistibuteMutation } from '@/hook';
import type { Task } from '@/type';

export const useWorkReallocateRatioSubmit = (
  task: Task,
  onSuccess: () => void,
) => {
  const { mutate: distribute } = useRatioDistibuteMutation();
  const form = useFormContext<WorkReallocateRatioFormData>();
  const { handleSubmit } = form;

  const onSubmit = handleSubmit(data => {
    distribute(
      {
        pTaskID: task.id,
        distributions: data.distributions,
      },
      { onSuccess },
    );
  });

  return { onSubmit };
};
